export const DEFAULT_TOTAL_SAVED_VEG = 300000;
